import React, { useEffect, useState } from 'react';
import axios from 'axios';
import styled from 'styled-components';
import PackageDialog from "../course/packagedialog";
import DashboardNavbar from "../dashboardNavbar"
import { Card, SectionHead, Btn, RowBetween } from '../ui/primitives';

const DetailsTable = styled.table`
  width: 100%;
  border-collapse: collapse;

  td {
    padding: 11px 14px;
    border-bottom: 1px solid ${({ theme }) => theme.border};
    font-size: 13px;
  }
  tr:last-child td { border-bottom: none; }
  td:first-child { color: ${({ theme }) => theme.textMuted}; font-weight: 600; width: 50%; }
  td:last-child { font-weight: 650; color: ${({ theme }) => theme.text}; }
`;

const PackagesTable = () => {
  const [packages, setPackages] = useState(null);
  const [planDetails, setPlanDetails] = useState(null);
  const userId = localStorage.getItem('userId');
  const apiUrl1 = process.env.REACT_APP_API_URL1;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [courseCount, setCourseCount] = useState(0);
  const [assessmentCount, setAssessmentCount] = useState(0);
  const [studentCount, setStudentCount] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
   const menuItems = [{
                "title": "Package & Plan",
                "link": "/Portal/Instructor/billing"
            },
            {
                "title": "Invoices",
                "link": "/Portal/Instructor/billing/invoices"
            }];
            
  const handleDialogOpen = () => {
    setDialogOpen(true);
};
const getBasicAuthHeader = () => {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const encodedCredentials = btoa(`${username}:${password}`);
  return `Basic ${encodedCredentials}`;
};
async function fetchDataAll() {
  try {
      // Fetch data for courses
  const token = localStorage.getItem('token');
      const responseCourses = await axios.get(apiUrl + `/api/course/${userId}`,{ headers: {
        'Content-Type': "application/json",
            "Accept": "*/*",
            "Access-Control-Allow-Origin": "*",
            'Authorization': getBasicAuthHeader(),}});
      setCourseCount(responseCourses.data.length);
      const body ={
        user_id:userId
      }
      // Fetch data for assessments
      const responseAssessments = await axios.post(apiUrl1 + `/api/get_tests_for_instructor_id`,body, {
        headers: {
          'Content-Type': "application/json",
          "Accept": "*/*",
          "Access-Control-Allow-Origin": "*",
          'Authorization': token,
          "X-Api-Version": 'v2'
        }
    });
      setAssessmentCount(responseAssessments.data.data.length);

      // Fetch data for students
      const responseStudents = await axios.get(apiUrl + `/api/studentcourses/${userId}`,{ 
        headers: {
           'Content-Type': "application/json",
            "Accept": "*/*",
            "Access-Control-Allow-Origin": "*",
            'Authorization': getBasicAuthHeader()
        }});
      setStudentCount(responseStudents.data.length);
  } catch (error) {
      console.error("Error fetching data:", error);
  }
}

  useEffect(() => {
    const fetchData = async () => {
      try {
        // First API call to fetch user's plan
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/userplans/${userId}`, {
          headers: {
            'Content-Type': "application/json",
            "Accept": "*/*",
            "Access-Control-Allow-Origin": "*",
            'Authorization': getBasicAuthHeader()
          },
        });

        const packagesData = response.data;
        setPackages(packagesData);

        // Check if planId is present in the user plan
        if (packagesData && packagesData.planId) {
          const planId = packagesData.planId;

          // Second API call to fetch details related to planId
          const planResponse = await axios.get(`${process.env.REACT_APP_API_URL}/api/packages/${planId}/${userId}`, {
            headers: {
              'Content-Type': "application/json",
            "Accept": "*/*",
            "Access-Control-Allow-Origin": "*",
            'Authorization': getBasicAuthHeader()
            },
          });
          setPlanDetails(planResponse.data);
        }
      } catch (error) {
        console.error('Error fetching packages or plan details:', error);
      }
    };

    fetchData();
    fetchDataAll()
  }, [userId]);

  const handleCancelSubscription = async () => {
    try {
        const subscriptionId = packages.subscriptionId;
        const body={
            subscriptionId:subscriptionId
        }
        console.log(body)
      await axios.post(apiUrl1+`/api/user/cancel-subscription`, body,{
        headers: {
            'Content-Type': 'application/json',
            'Accept': '*/*',
            'Access-Control-Allow-Origin': '*',
            'Authorization': localStorage.getItem('token'),
          "X-Api-Version": 'v2'
        },
      });
      console.log('Current user plan canceled successfully');
    } catch (error) {
      console.error('Error canceling current user plan:', error);
    }
  };

  if (!packages || !planDetails) {
    return <div>Loading...</div>;
  }

  return (
    <>
    <DashboardNavbar menuItems={menuItems} />
    <PackageDialog open={dialogOpen} handleClose={()=> setDialogOpen(false)} />
    <div style={{ maxWidth: 720, margin: '0 auto' }}>
      <RowBetween style={{ marginBottom: 12 }}>
        <SectionHead style={{ margin: 0 }}>
          <div>
            <h2>Package details</h2>
            <p>Your current plan and usage.</p>
          </div>
        </SectionHead>
        <div style={{ display: 'flex', gap: 10 }}>
          <Btn onClick={handleDialogOpen}>Upgrade Plan</Btn>
          <Btn $variant="danger" onClick={handleCancelSubscription}>Cancel Subscription</Btn>
        </div>
      </RowBetween>
      <Card $pad key={packages.id}>
        <DetailsTable>
          <tbody>
            <tr><td>Package Name</td><td>{planDetails.name}</td></tr>
            <tr><td>Price</td><td>${packages.price}</td></tr>
            <tr><td>Number of Assessments</td><td>{assessmentCount}/{planDetails.assessments}</td></tr>
            <tr><td>Number of Students</td><td>{studentCount}/{planDetails.students}</td></tr>
            <tr><td>Number of Courses</td><td>{courseCount}/{planDetails.courses}</td></tr>
            <tr><td>Number of Instructors</td><td>{planDetails.instructors}</td></tr>
            <tr><td>In-App Purchase</td><td>{planDetails.inAppPurchase ? 'Yes' : 'No'}</td></tr>
            <tr><td>Next Payment Date</td><td>{new Date(packages.nextPlanDate).toLocaleDateString()}</td></tr>
          </tbody>
        </DetailsTable>
      </Card>
    </div>
    </>
  );
};

export default PackagesTable;
